import React from "react";
import bg from "../assets/bg.png";
import Frame from "../assets/Frame.png";
import Navbar from "../components/Navbar/Navbar";
import Footer from "./../components/Footer/footer";
import DropdownComponent from "../components/Dropdown/dropdown";
import Farmer from "../components/Farmer";

const Address: React.FC = () => {
  return (
    <div
      className="p-3 bg-fixed bg-center bg-no-repeat flex flex-col min-h-screen"
      style={{ backgroundImage: `url(${bg})` }}
    >
      <Farmer />
      <Navbar />
      <div className="flex-grow">
        <div className="max-w-faqMax-width  w-full mx-auto bg-gradient-bg from-opacity-5 to-opacity-0 rounded-2xl p-3 md:p-5 md:px-8 text-white flex flex-col gap-2 mt-2 lg:mt-4">
          <h1 className="text-white text-24 md:text-xl font-bold tracking1 uppercase">
            FREE ADDRESS
          </h1>
          <p className="text-dark_white text-sm mb-1">
            At vero eos et accusamus et iusto odio dignissimos ducimus qui
            blanditiis praesentium voluptatum deleniti atque corrupti quos
            dolores et quas molestias excepturi sint.
          </p>

          <p className="text-dark_white text-sm">
            Occaecati cupiditate non provident similique sunt in culpa qui
            officia deserunt mollitia animi id est laborum et dolorum fuga. Et
            harum quidem rerum facilis est et expedita distinctio.
          </p>
          <p className="text-base font-normal">
            Please select the network and enter the amount you want to send.
          </p>

          <hr className="max-w-hrMax-width w-full h-px mx-auto border border-transparent_200 my-3" />
          <DropdownComponent />

          <div className="border border-transparent_200 rounded-3xl flex items-center gap-4 w-full p-2 px-3 mt-3">
            <div className="flex justify-center items-center w-10 h-10 border border-transparent_200 rounded-xl">
              <img src={Frame} alt="frame" className="h-4" />
            </div>
            <div className="flex flex-col">
              <h4 className="text-sm font-medium">0.0000068 ETH </h4>
              <span className="text-10 text-white text-opacity-50">
                Balance 0.0000539 ETH
              </span>
            </div>
          </div>

          <hr className="w-full h-px border border-transparent_200 my-3" />
          <ul className="flex justify-between items-center text-transparent_500 text-sm">
            <li>Transaction Fee</li>
            <li>0.00025 ETH</li>
          </ul>

          <button className="w-full bg-vibrant_yellow rounded-xl text-black font-semibold text-base uppercase p-3 my-3">
            SEND
          </button>

          <hr className="max-w-hrMax-width w-full h-px mx-auto border border-transparent_200 my-3 lg:block hidden" />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Address;
